import React, {  useState } from 'react';
import classNames from 'classnames';
import LeftMenu from 'navigations/leftMenu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faCaretDown, faCaretUp, faUser, faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons"
import useLeftMenu from 'hooks/useLeftMenu';
import { MENUS, PAGE_NAV } from 'configs/page';
// import { Redirect } from 'react-router-dom';
// import useLogout from 'hooks/useLogout';
import useFullRegOnly from "hooks/useFullRegOnly";
// import useAuth from 'hooks/useAuth';
// import useAuthProvider from 'hooks/useAuthProvider';
import useAccount from 'hooks/useAccount';
import Footer from "components/Footer";
import Languages from '../components/Languages';

const LoggedInDisplay  = (props) => {
    const { children, history, pageTitle, subPageTitle } = props;

    const [leftMenu] = useLeftMenu();


        const accountProvider = useAccount();
        const { profiles } = accountProvider;
        const { Name } = profiles;
    
    // const logoutProvider = useLogout();
    const [mobileNavOn, setMobileNavOn] = useState(false);
    const [accNavOn, setAccNavOn] = useState(false);
    const [, setDateSelDropdownOn] = useState(false);

    const onMenuClicked = (e, menu) => {
        e.preventDefault();
        // if (menu.value === "LOGOUT") {
        //     logoutProvider().then(() => { history.push(PAGE_NAV.LOGIN) });
        //     return;
        // }
        history.push(PAGE_NAV[menu.value]);
    }

    return (
        <>
            {
               useFullRegOnly(
                    <div className={classNames("main", leftMenu.value.toLowerCase(), "affiliate")} onClick={() => { setMobileNavOn(false); setAccNavOn(false); setDateSelDropdownOn(false); }}>
                        <div className="main-content">
                            <LeftMenu on={mobileNavOn} {...props} />
                            <div className='page-container'>
                            <div className={classNames("section", "content")} >
                                <div className="section-header">
                                    <div className="page-title">
                                        <p className="mobile-nav-btn">
                                            <a href="/">
                                                <FontAwesomeIcon icon={faBars} onClick={(e) => { e.preventDefault(); setMobileNavOn(!mobileNavOn); e.stopPropagation() }} />
                                            </a>
                                        </p>
                                        <div className='desktop-header'>
                                            <h1>{!pageTitle ? leftMenu.text : pageTitle}</h1>
                                            <p className='sub-page-title'>{subPageTitle}</p>
                                        </div>
                                        <Languages />
                                        {/* <div className="user">
                                            <div className="avatar">
                                                <a href="/" onClick={(e) => { e.preventDefault(); setAccNavOn(!accNavOn); e.stopPropagation() }}>
                                                    {Name.slice(0, 1)}
                                                </a>
                                            </div>
                                            <div className='username'>
                                                <a href="/" onClick={(e) => { e.preventDefault(); setAccNavOn(!accNavOn); e.stopPropagation() }}>
                                                {Name}</a>
                                            </div>

                                            <FontAwesomeIcon className='arrow' icon={accNavOn ? faChevronUp : faChevronDown} onClick={(e) => { setAccNavOn(!accNavOn); e.stopPropagation() }} />

                                            <div className={classNames("account-nav", { "on": accNavOn })}>
                                                <ul>
                                                    {
                                                        MENUS.filter(menu => menu.positions.includes("account")).map((menu, i) => <li key={`menu_${i}`}><a href={PAGE_NAV[menu.value]} onClick={(e) => { onMenuClicked(e, menu) }} title={menu.text}><img alt={menu.text} src={menu.icon} title={menu.text} /> <span>{menu.text}</span></a></li>)
                                                    }

                                                </ul>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                                {children}
                            </div>
                            <Footer loggedin={true} />
                            </div>

                        </div>
                        
                    </div>)
            }
        </>
    );
}

const LoggedInLayout = (props) => {
    return (
        <>              
            <LoggedInDisplay {...props} />
        </>
    );
}

export default LoggedInLayout;